// frontend/src/hooks/formatSearchResults.js

export function formatSearchResults(results, maxResults = 3) {
    if (!Array.isArray(results) || results.length === 0) return '';
  
    const limited = results.slice(0, maxResults);
  
    const formatted = limited.map((item, index) => {
      const title = item.title?.trim() || 'Untitled';
      const snippet = item.snippet?.trim() || 'No description available.';
      return `🔹 **${index + 1}. ${title}**\n_${snippet}_`;
    });
  
    return `📚 **Based on recent search results:**\n\n${formatted.join('\n\n')}\n\n`;
  }
  